var paymentComponent = null;

function clientZiftCallback(responseCode, responseMessage, proxyNumber) {
    if (responseCode === "A01") {
        paymentComponent.processZiftTemporaryCode("*" + proxyNumber);
    } else {
        console.log("responseCode: ", responseCode);
        console.log("responseMessage: ", responseMessage);
        alert(responseMessage);
        return false;
    }
}